import { Trash2 } from "react-feather"
import { Button } from "reactstrap"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { deleteById } from "@lib/api"

const DeleteConfirmation = ({ id, endpoint, onSuccess, children }) => {
  const confirmationModal = () => {
    const MySwal = withReactContent(Swal)
    MySwal.fire({
      title: "Confirm",
      html: (
        <p>
          Do you really want to <b>delete</b> this ?
        </p>
      ),
      customClass: {
        input: "mx-3",
        cancelButton: "btn btn-light ms-1",
        confirmButton: "btn btn-danger mx-1"
      },
      buttonsStyling: false,
      cancelButtonText: "Cancel",
      confirmButtonText: "Delete",
      showCancelButton: true,
      showLoaderOnConfirm: true,
      async preConfirm() {
        return await deleteById(id, endpoint)
      }
    }).then(function (res) {
      if (res.isConfirmed) {
        if (res.value.status === 204) {
          MySwal.fire({
            position: "bottom-end",
            icon: "success",
            title: "Deleted",
            showConfirmButton: false,
            timer: 1200,
            backdrop: false
          })
          onSuccess()
        } else {
          MySwal.fire({
            title: "Error",
            html: (
              <div>
                <p>
                  An error occured while deleting the item.
                  <br />
                  [id: {id}, endpoint: {endpoint}]
                </p>
              </div>
            ),
            icon: "error",
            allowOutsideClick: false,
            allowEscapeKey: false,
            customClass: {
              confirmButton: "btn btn-primary"
            }
          })
        }
      }
    })
  }

  return (
    <div onClick={confirmationModal}>
      {children ? (
        children
      ) : (
        <Button color="flat-danger" size="sm">
          <Trash2 size={17} />
        </Button>
      )}
    </div>
  )
}

export default DeleteConfirmation
